import { Controller, type Control } from "react-hook-form";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import { TraderDetailsProfileField } from "../TraderDetailsProfileField";
import type {
  TraderDetailsFieldErrorGetter,
  TraderDetailsStepOneFormValues,
} from "../TraderDetailsStepOne/types";

interface TraderDetailsVendorFieldsProps {
  control: Control<TraderDetailsStepOneFormValues>;
  getFieldError: TraderDetailsFieldErrorGetter;
  isDisabled?: boolean;
  isWfpVendorValue?: boolean | null;
  vendorLabel: string;
  wingsIdLabel: string;
}

export const TraderDetailsVendorFields = ({
  control,
  getFieldError,
  isDisabled = false,
  isWfpVendorValue,
  vendorLabel,
  wingsIdLabel,
}: TraderDetailsVendorFieldsProps) => (
  <div className="grid gap-5 md:grid-cols-2">
    <Controller
      control={control}
      name="is_wfp_vendor"
      render={({ field }) => (
        <div className="rounded-lg border border-border px-4 py-3">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <Label htmlFor="is_wfp_vendor-switch" className="font-semibold text-foreground">
              {vendorLabel}
            </Label>
            <Switch
              id="is_wfp_vendor-switch"
              checked={!!field.value}
              onCheckedChange={field.onChange}
              onBlur={field.onBlur}
              disabled={isDisabled}
            />
          </div>
        </div>
      )}
    />

    {isWfpVendorValue ? (
      <Controller
        control={control}
        name="wings_id"
        render={({ field }) => {
          const errorMessage = getFieldError("wings_id");

          return (
            <TraderDetailsProfileField
              id="wings_id-input"
              label={wingsIdLabel}
              errorMessage={errorMessage}
            >
              <Input
                {...field}
                id="wings_id-input"
                value={field.value ?? ""}
                aria-invalid={!!errorMessage}
                aria-describedby={errorMessage ? "wings_id-input-error" : undefined}
                disabled={isDisabled}
                className="border-border"
              />
            </TraderDetailsProfileField>
          );
        }}
      />
    ) : null}
  </div>
);
